import React from "react";

const Youtube = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true" 
      focusable="false"
    >
      <path
        d="M18.8683 5.72987C18.6679 4.6224 17.991 3.91148 16.9328 3.71793C16.4962 3.63777 16.0515 3.57936 15.608 3.55931C13.7272 3.47428 11.8456 3.40757 9.96419 3.33398C9.96362 3.35345 9.96305 3.37292 9.96247 3.39239C9.52985 3.39239 9.09694 3.38609 8.66461 3.39354C6.87084 3.4236 5.07679 3.44336 3.29247 3.66611C2.18271 3.8044 1.41395 4.46436 1.1829 5.56152C1.05377 6.17423 0.983334 6.80241 0.932369 7.42744C0.823283 8.76424 0.79637 10.1053 0.891426 11.4442C0.950407 12.2722 1.02599 13.1028 1.16371 13.9208C1.34438 14.9922 2.08279 15.7005 3.1224 15.8548C3.73797 15.9462 4.35957 16.0241 4.98087 16.0444C6.88802 16.1062 8.79631 16.1635 10.7043 16.1729C12.6063 16.1827 14.5092 16.1374 16.4037 15.9385C16.8922 15.8869 17.3735 15.809 17.8004 15.5356C18.5064 15.0835 18.8277 14.4041 18.9047 13.6061C19.0086 12.5264 19.114 11.4442 19.1495 10.361C19.2007 8.8112 19.1452 7.26195 18.8683 5.72987ZM8.18703 12.519V7.04606C9.77551 7.95912 11.3474 8.86274 12.947 9.78238C11.3497 10.7009 9.77809 11.6042 8.18703 12.519Z"
        fill="white"
      />
    </svg>
  );
};

export default Youtube;
